import { render, staticRenderFns } from "./score.vue?vue&type=template&id=bb01ba7c&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"
import style0 from "./score.vue?vue&type=style&index=0&id=bb01ba7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb01ba7c",
  null
  
)

export default component.exports